import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { MainContentComponent } from './layouts/main-content/main-content.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { LoginComponent } from './layouts/login/login.component';
import { SignupComponent } from './layouts/signup/signup.component';
import { MainComponent } from './views/main/main.component';
import { MainSidebarComponent } from './layouts/main-sidebar/main-sidebar.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { ManageDeviceComponent } from './layouts/manage-device/manage-device.component';
import { ActivityHistoryComponent } from './layouts/activity-history/activity-history.component';
import { ManageUserComponent } from './layouts/manage-user/manage-user.component';
import { LicenseSummaryComponent } from './layouts/license-summary/license-summary.component';
import { FaqSupportComponent } from './layouts/faq-support/faq-support/faq-support.component';
import { FooterComponent } from './components/footers/footer.component';
import { SupportCardComponent } from './components/cards/support-card/support-card/support-card.component';
import { MyAccountComponent } from './layouts/my-account/my-account.component';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { NgOtpInputModule } from 'ng-otp-input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ToastrModule } from 'ngx-toastr';
import { GaugeChartModule } from 'angular-gauge-chart';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CreatePasswordComponent } from './layouts/create-password/create-password.component';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { NgxCaptchaModule } from 'ngx-captcha';
import { GoogleFbSignupComponent } from './layouts/google-fb-signup/google-fb-signup.component';
import { AddDeviceComponent } from './layouts/add-device/add-device.component';
import { NgxOrgChartModule } from 'ngx-org-chart';
import { ManageUsersTreeViewComponent } from './layouts/manage-users-tree-view/manage-users-tree-view.component';
import { ParentalControlComponent } from './layouts/parental-control/parental-control.component';
import { NgChartsModule } from 'ng2-charts';
import { ScoreManagementComponent } from './layouts/score-management/score-management.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { OwlModule } from 'ngx-owl-carousel';
import { MainHeadingComponent } from './components/headings/main-heading/main-heading.component';
import { TabTitleComponent } from './components/tabs/tab-title/tab-title.component';
import { TabContentComponent } from './components/tabs/tab-content/tab-content.component';
import { LinkExpiredComponent } from './layouts/link-expired/link-expired.component';
import { TabTitleInlineComponent } from './components/tabs/tab-title-inline/tab-title-inline.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ReCaptchaModule } from 'angular-recaptcha3';
import { environment } from 'src/environments/environment.prod';
import { ProductKeyDirective } from './utils/mask';
import { LoaderComponent } from './components/loader/loader.component';
import { PaginationConfig, PaginationModule } from 'ngx-bootstrap/pagination';
import { LocateComponent } from './layouts/locate/locate.component';
import { AntiTheftComponent } from './layouts/anti-theft/anti-theft.component';
import { LockComponent } from './layouts/lock/lock.component';
import { WipeComponent } from './layouts/wipe/wipe.component';
import { ScanDeviceComponent } from './layouts/scan-device/scan-device.component';
import { UpdateVirusComponent } from './layouts/update-virus/update-virus.component';
import { SyncDeviceComponent } from './layouts/sync-device/sync-device.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SecurityScoreComponent } from './layouts/security-score/security-score.component';
import { NgxGaugeModule } from 'ngx-gauge';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { SecurityScroreComponent } from './security-scrore/security-scrore.component';
import { PrivacyScroreComponent } from './privacy-scrore/privacy-scrore.component';
import { LastUpdatedOnComponent } from './layouts/last-updated-on/last-updated-on.component';
import { OnlyNumberDirective } from './utils/only-number.directives';
import { RingDeviceComponent } from './layouts/ring-device/ring-device.component';
import { SortDirective } from './utils/sort.directive';
import { SystemSignUpComponent } from './layouts/system-sign-up/system-sign-up.component';
import { SidebarOverlayComponent } from './components/sidebar-overlay/sidebar-overlay.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxPaginationModule } from 'ngx-pagination';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { SyncScoreComponent } from './layouts/sync-score/sync-score.component';
import { AddUserComponent } from './layouts/add-user/add-user.component';
import { ChangeOwnerComponent } from './layouts/change-owner/change-owner.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DesktopSettingsComponent } from './layouts/desktop-settings/desktop-settings.component';
import { ManageDeviceControlComponent } from './layouts/manage-device-control/manage-device-control.component';
import { NotificationViewMoreComponent } from './layouts/notification-view-more/notification-view-more.component';
import { ResetPasswordComponent } from './layouts/reset-password/reset-password.component';
// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    MainContentComponent,
    SidebarComponent,
    LoginComponent,
    SignupComponent,
    MainComponent,
    MainSidebarComponent,
    DashboardComponent,
    NavbarComponent,
    ManageDeviceComponent,
    ManageDeviceControlComponent,
    // ScoreCardComponent,
    ActivityHistoryComponent,
    ManageUserComponent,
    LicenseSummaryComponent,
    FaqSupportComponent,
    FooterComponent,
    SupportCardComponent,
    MyAccountComponent,
    CreatePasswordComponent,
    GoogleFbSignupComponent,
    AddDeviceComponent,
    ManageUsersTreeViewComponent,
    ParentalControlComponent,
    ScoreManagementComponent,
    MainHeadingComponent,
    TabTitleComponent,
    TabContentComponent,
    LinkExpiredComponent,
    TabTitleInlineComponent,
    DesktopSettingsComponent,
    ProductKeyDirective,
    LoaderComponent,
    LockComponent,
    LocateComponent,
    AntiTheftComponent,
    WipeComponent,
    ScanDeviceComponent,
    UpdateVirusComponent,
    SyncDeviceComponent,
    SecurityScoreComponent,
    SecurityScroreComponent,
    PrivacyScroreComponent,
    LastUpdatedOnComponent,
    OnlyNumberDirective,
    SortDirective,
    RingDeviceComponent,
    SystemSignUpComponent,
    SidebarOverlayComponent,
    SyncScoreComponent,
    AddUserComponent,
    ChangeOwnerComponent,
    DesktopSettingsComponent,
    ManageDeviceControlComponent,
    NotificationViewMoreComponent,
    ResetPasswordComponent
  ],
  imports: [
    BrowserModule,
    RxReactiveFormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    TabsModule.forRoot(),
    HttpClientModule,
    NgOtpInputModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      preventDuplicates: true,
      maxOpened: 1,
    }),
    GaugeChartModule,
    NgxCaptchaModule,
    NgbModule,
    ImageCropperModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),

    ReCaptchaModule.forRoot({
      invisible: {
        sitekey: environment.captchaKey,
      },
      normal: {
        sitekey: environment.captchaKey,
      },
      language: 'en',
    }),

    FormsModule,
    NgxOrgChartModule,
    NgChartsModule,
    CarouselModule,
    OwlModule,
    NgxIntlTelInputModule,
    PaginationModule.forRoot(),
    GoogleMapsModule,
    NgxGaugeModule,
    GaugeChartModule,
    Ng2SearchPipeModule,
    NgxPaginationModule,
    NgSelectModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    DatePipe,
    PaginationConfig,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
